import TyReplyContent from './TyReplyContent.vue'
export default TyReplyContent



// WEBPACK FOOTER //
// ./src/components/ty-reply-content/index.js